module.exports = require('./helpers/bundle-url').getBundleURL('et4eZ') + "logo-dark.eefe0b7f.svg";